/**
 * Identifiants de glisser-déposer des équipes.
 *
 * ## Le bug qu'ils corrigent
 *
 * Une même équipe est rendue à DEUX endroits en même temps : dans le rail des
 * équipes à placer, et dans le couloir de la heat où elle est déjà placée. Ce
 * n'est pas un cas limite mais le cas NOMINAL — « non assignée » est relatif à
 * un WOD (une équipe placée sur le WOD 1 reste à placer pour le WOD 2), donc
 * elle reste dans le rail pendant qu'elle occupe un couloir.
 *
 * Les deux cartes portaient le même `draggableId` : `team-<uuid>`. Or dnd
 * indexe ses draggables PAR IDENTIFIANT, dans tout le `DragDropContext`. Avec
 * un doublon, il en résout un au hasard — d'où le symptôme relevé par Bryan le
 * 2026-08-16 : « quand j'ai la souris pour sélectionner l'équipe dans le rail,
 * je vois celle de mon ancienne heat se déplacer ». Le doublon n'apparaissait
 * qu'une fois une heat dépliée, puisque les couloirs ne sont montés qu'à ce
 * moment-là — ce qui explique que le geste marche d'abord, puis déraille.
 *
 * ## La règle
 *
 * Un identifiant nomme son CONTENEUR autant que son contenu. Deux cartes de la
 * même équipe dans deux endroits différents sont deux objets différents à
 * l'écran, elles doivent l'être pour dnd aussi.
 *
 * Les fonctions vivent ici plutôt qu'en gabarits recopiés : c'est leur
 * dispersion dans trois fichiers qui avait laissé la collision passer.
 */

/** Carte d'équipe dans le rail des équipes à placer. */
export const railTeamDragId = (teamId: string) => `rail-team-${teamId}`;

/**
 * Carte d'équipe dans un couloir.
 *
 * La heat fait partie de l'identifiant : deux heats peuvent afficher la même
 * équipe — une par WOD — et être dépliées en même temps.
 */
export const laneTeamDragId = (heatId: string, teamId: string) =>
  `lane-${heatId}-team-${teamId}`;

/** Équipe désignée par un identifiant de glisser, quel que soit son conteneur. */
export const teamIdFromDragId = (dragId: string): string =>
  dragId.replace(/^rail-team-/, '').replace(/^lane-[0-9a-fA-F-]+-team-/, '');
